export default __webpack_public_path__ + "static/media/GI.85a11cb2.ico";